import React from 'react';
import { cn } from '@/utils/cn';

interface TutaraRadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const TutaraRadio = React.forwardRef<HTMLInputElement, TutaraRadioProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          ref={ref}
          type="radio"
          className={cn(
            'w-4 h-4 border-2 transition-all',
            'border-gray-300 dark:border-gray-600',
            'text-tutara-turquoise',
            'focus:ring-2 focus:ring-tutara-turquoise focus:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          {...props}
        />
        {label && (
          <span className={cn(
            'text-sm text-tutara-charcoal dark:text-gray-200',
            props.disabled && 'text-tutara-gray'
          )}>
            {label}
          </span>
        )}
      </label>
    );
  }
);

TutaraRadio.displayName = 'TutaraRadio';